module.exports = __webpack_public_path__ + "img/p4.6313ffb3.png";